import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ContractEffects } from "./effects/contract.effects";
import { EffectsModule } from "@ngrx/effects";
import { RegionEnum } from "@edp-enums/region.enum";
import { Request } from "@edp-utils/request.utils";
import { getRegionByTLD } from "@edp-utils/region.utils";
import { ContractEsEffects } from "./effects/ES/contract-es.effects";

function checkRegion(): RegionEnum {
    if (Request.getParameter("region")) {
        const regionQueryParam = Request.getParameter("region");
        const region: RegionEnum = Object.keys(RegionEnum).includes(regionQueryParam) ? RegionEnum[regionQueryParam] : getRegionByTLD();
        return region;
    }
    return getRegionByTLD();
}

@NgModule({
    imports: [EffectsModule.forFeature([checkRegion() === RegionEnum.ES ? ContractEsEffects : ContractEffects])],
})
export class EffectsContractsModule {}
